import { MenuOptionValue } from './types';

export const headerTitle = 'Admin Panel';

export const menuTitle = 'Options';

export const errorMessageUnhandledCase = 'Unhandled menu option:';

export const agentConfigurationTexts = {
    noAgentsFound: 'No agents found',
    selectAgentLabel: 'Agent',
    instructionsLabel: 'Instructions',
    instructionsError: 'Instructions field cannot be empty',
    topPLabel: 'Top P',
    topPError: 'Top P must be a number',
    topPMinError: 'Top P cannot be less than',
    topPMaxError: 'Top P cannot be greater than',
    temperatureLabel: 'Temperature',
    temperatureError: 'Temperature must be a number',
    temperatureMinError: 'Temperature cannot be less than',
    temperatureMaxError: 'Temperature cannot be greater than',
    maxTokensLabel: 'Max Tokens',
    maxTokensError: 'Max Tokens must be a number',
    maxTokensIntError: 'Max Tokens must be an integer',
    maxTokensMinError: 'Max Tokens cannot be less than',
    maxTokensMaxError: 'Max Tokens cannot be greater than',
};

export const regionalKnowledgeFilesTexts = {
    noFileUploadConstraintsFound: 'No file upload constraints found.',
    noSupportedCountriesFound: 'No supported countries found.',
    noDocumentsFound: 'No documents found.',
    uploadFilesLabel: 'Select files to upload:',
    selectedFilesLabel: 'Files to upload:',
    tableMainLabel: 'Documents List',
    tableNameColumnLabel: 'Name:',
    tableCreatedOnColumnLabel: 'Created On:',
    tableActionsColumnLabel: 'Actions:',
};

export const avatarConfigurationTexts = {
    noLanguagesFound: 'No languages found',
    selectLanguagesLabel: 'Select languages avatar can recognize and answer in:',
    selectLanguagesError: 'You must select at least one language',
};

export const predefinedPromptsByRoleTexts = {
    noRolesFound: 'No roles found',
    formTitle: 'Here you can set predefined prompts for each role:',
    promptLabel: 'Prompt #',
    labelInputTitle: 'Prompt label',
    textInputTitle: 'Prompt content',
    labelInputError: 'Label field cannot be empty',
    textInputError: 'Text field cannot be empty',
};

export const generalPredefinedPromptsTexts = {
    formTitle:
        'Here you can set up default (visible to all users) predefined prompts and divide them into groups:',
    promptLabel: 'Prompt #',
    groupInputTitle: 'Group name',
    labelInputTitle: 'Prompt label',
    textInputTitle: 'Prompt content',
    groupInputError: 'Group name cannot be empty',
    labelInputError: 'Label field cannot be empty',
    textInputError: 'Text field cannot be empty',
    deleteGroupButton: 'Delete this group',
};

export const menuItems = [
    {
        label: 'Agent Configuration',
        value: MenuOptionValue.AgentConfiguration,
    },
    {
        label: 'Regional Knowledge Files',
        value: MenuOptionValue.RegionalKnowledgeFiles,
    },
    {
        label: 'Avatar Configuration',
        value: MenuOptionValue.AvatarConfiguration,
    },
    {
        label: 'General Predefined Prompts',
        value: MenuOptionValue.GeneralPredefinedPrompts,
    },
    {
        label: 'Predefined Prompts by Role',
        value: MenuOptionValue.PredefinedPromptsByRole,
    },
] as const;

export const indexerTexts = {
    title: 'Indexer Status:',
    connectionOpen: 'Ready.',
    connectionClosed: 'Connection closed.',
    invalidMessage: 'Invalid message.',
    errorFromWebsocket: 'Websocket connection failed.',
};

export const snackbarTexts = {
    success: 'Settings have been updated successfully!',
    partialSuccess: 'Some files have been uploaded successfully, but some have failed.',
    uploadedLabel: 'List of uploaded files:',
    failedLabel: 'List of failed files:',
    error: 'Sorry, something went wrong:',
};

export const buttons = {
    close: 'Close',
    submit: 'Upload changes',
};
